/** Stati della macchina, nell'ordine del ciclo di vita. */
export const MACHINE_STATUSES = [
    'DRAFT',
    'IN_SERVICE',
    'OUT_OF_SERVICE',
    'DECOMMISSIONED',
];
/** Le macchine non dismesse: la base di «Attive», scadute e anomalie. */
export const LIVE_MACHINE_STATUSES = MACHINE_STATUSES.filter((status) => status !== 'DECOMMISSIONED');
/** Scadenza delle verifiche filtrabile dalla lista (un solo valore). */
export const MACHINE_LIST_DUE_FILTERS = [
    'OVERDUE',
    'DUE_SOON',
    'NO_PLAN',
];
/** Viste rapide della lista (`?tab=`), nell'ordine delle schede. */
export const MACHINE_LIST_VIEWS = [
    'ACTIVE',
    'OVERDUE',
    'FINDINGS',
    'DECOMMISSIONED',
    /** Nessun filtro di stato: il link «Vedi tutte» della scheda cliente. */
    'ALL',
];
/**
 * Viste che filtrano su verifiche e anomalie: il backend risponde 403 a
 * `due` e `hasOpenFindings` senza la risorsa «verifiche».
 */
const CHECK_VIEWS = ['OVERDUE', 'FINDINGS'];
/** Viste consentite a chi guarda la lista. */
export function visibleMachineListViews({ canSeeChecks, }) {
    return MACHINE_LIST_VIEWS.filter((view) => canSeeChecks || !CHECK_VIEWS.includes(view));
}
/** Filtri API della vista, da combinare con ricerca e pannello. */
export function machineListViewFilters(view) {
    switch (view) {
        case 'OVERDUE':
            return { statuses: [...LIVE_MACHINE_STATUSES], due: 'OVERDUE' };
        case 'FINDINGS':
            return { statuses: [...LIVE_MACHINE_STATUSES], hasOpenFindings: true };
        case 'DECOMMISSIONED':
            return { statuses: ['DECOMMISSIONED'] };
        case 'ALL':
            return {};
        default:
            return { statuses: [...LIVE_MACHINE_STATUSES] };
    }
}
/**
 * Vista + pannello Filtri (+ ricerca, ordinamento) in una sola query. Gli
 * stati si intersecano e la scadenza, se la fissano entrambi, deve
 * coincidere. `null` = combinazione impossibile (es. «Dismesse» con lo stato
 * «In servizio»): l'insieme è vuoto per costruzione, e ignorare uno dei due
 * filtri mostrerebbe righe che l'altro esclude.
 */
export function combineMachineListFilters(view, panel) {
    // Un elenco di stati vuoto non filtra (come nella lista), non svuota.
    const panelStatuses = panel.statuses?.length ? panel.statuses : undefined;
    const statuses = view.statuses && panelStatuses
        ? view.statuses.filter((status) => panelStatuses.includes(status))
        : (panelStatuses ?? view.statuses);
    if (statuses && statuses.length === 0)
        return null;
    if (view.due && panel.due && view.due !== panel.due)
        return null;
    const due = view.due ?? panel.due;
    // `hasOpenFindings=false` vuol dire «nessun filtro»: non annulla la vista.
    const hasOpenFindings = view.hasOpenFindings || panel.hasOpenFindings;
    // Gli altri filtri del pannello passano invariati; questi tre li decide
    // la combinazione con la vista.
    const rest = { ...panel };
    delete rest.statuses;
    delete rest.due;
    delete rest.hasOpenFindings;
    return {
        ...rest,
        ...(statuses ? { statuses } : {}),
        ...(due ? { due } : {}),
        ...(hasOpenFindings ? { hasOpenFindings: true } : {}),
    };
}
/**
 * Opzioni del pannello per la vista aperta: quelle compatibili più quelle
 * già scelte (anche incompatibili), così un valore che svuota la lista si
 * vede e si toglie dal pannello stesso. Ordine del ciclo di vita.
 */
export function machineListPanelOptions(view, selected = {}) {
    const filters = machineListViewFilters(view);
    const allowedStatuses = filters.statuses ?? MACHINE_STATUSES;
    return {
        statuses: MACHINE_STATUSES.filter((status) => allowedStatuses.includes(status) || selected.statuses?.includes(status)),
        dues: MACHINE_LIST_DUE_FILTERS.filter((due) => !filters.due || due === filters.due || due === selected.due),
    };
}
/** Stati scelti che filtrano davvero nella vista aperta (per la pill). */
export function effectiveMachineListStatuses(view, statuses) {
    const allowed = machineListViewFilters(view).statuses ?? MACHINE_STATUSES;
    return statuses.filter((status) => allowed.includes(status));
}
//# sourceMappingURL=machine-list-views.js.map